import { Checkbox, FormControlLabel, Stack, TextField } from "@mui/material";
import { RoomContext } from "App/context";
import { useSocket } from "common/hooks/useSocket";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

type TimerDraftSelectorType = {};

// Timer appliqué quand on réactive le timer après l'avoir coupé.
const DEFAULT_MINUTES = 5;

/*
  Réglable par l'admin du salon, en solo comme en multijoueur. `timer: 0` signifie « pas de
  limite de temps ».
*/
const TimerDraftSelector = (props: TimerDraftSelectorType) => {
  const { t } = useTranslation();
  const socket = useSocket();
  const { draftModel, admin } = useContext(RoomContext);
  const disabledTimer = draftModel.timer === 0;
  const [lastMinutes, setLastMinutes] = useState<number>(
    disabledTimer ? DEFAULT_MINUTES : draftModel.timer / 60,
  );

  const emitTimer = (timer: number) =>
    socket.emit("update-draft-model", { ...draftModel, timer });

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <TextField
        disabled={!admin || disabledTimer}
        label={t("Temps par joueur (min)")}
        type="number"
        value={disabledTimer ? "" : draftModel.timer / 60}
        onChange={(evt) => {
          if (evt.target.value !== undefined) {
            const value = parseInt(evt.target.value);
            if (value >= 1 && value <= 99) {
              setLastMinutes(value);
              emitTimer(value * 60);
            }
          }
        }}
        sx={{ width: "12rem" }}
      />
      <FormControlLabel
        disabled={!admin}
        control={
          <Checkbox
            size="small"
            checked={disabledTimer}
            onChange={(evt) =>
              emitTimer(evt.target.checked ? 0 : lastMinutes * 60)
            }
          />
        }
        label={t("Sans timer")}
      />
    </Stack>
  );
};

export default TimerDraftSelector;
